import React from "react";

function TablaTrabajadoresCentros() {
  return (
    <div className="tablaGrafica">
      <h5 className="tituloTabla">NÚMERO DE TRABAJADORES POR CENTRO DE TRABAJO</h5>
      <table>
        <thead>
          <tr>
            <th>ClaveCT</th>
            <th>DescripcionCT</th>
            <th>Trabajadores</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>30MSU04315H</td>
            <td>BENEMERITA ESCUELA NORMAL VERACRUZANA ENRIQUE C. REBSAMEN</td>
            <td>630</td>
          </tr>
          <tr>
            <td>30ADG2636F</td>
            <td>DIRECCION GENERAL DE BACHILLERATO</td>
            <td>463</td>
          </tr>
          <tr>
            <td>30MSU0080L</td>
            <td>UNIVERSIDAD PEDAGOGICA VERACRUZANA</td>
            <td>384</td>
          </tr>
          <tr>
            <td>30EBH02308</td>
            <td>ANTONIO MARIA DE RIVERA</td>
            <td>326</td>
          </tr>
          <tr>
            <td>30ADG2105R</td>
            <td>DEPARTAMENTO DE ADMINISTRACION DE PERSONAL ESTATAL</td>
            <td>248</td>
          </tr>
          <tr>
            <td>30EBH0018F</td>
            <td>ILUSTRE INSTITUTO VERACRUZANO</td>
            <td>239</td>
          </tr>
          <tr>
            <td>30EBH0061U</td>
            <td>ARTICULO 3RO CONSTITUCIONAL</td>
            <td>236</td>
          </tr>
          <tr>
            <td>30MSU0416G</td>
            <td>ESCUELA NORMAL SUPERIOR VERACRUZANA DR. MANUEL SUAREZ TRUJILLO</td>
            <td>193</td>
          </tr>
          <tr>
            <td>30EBH0079T</td>
            <td>COLEGIO PREPARATORIO DE XALAPA</td>
            <td>171</td>
          </tr>
          <tr>
            <td>30EBH0006A</td>
            <td>BACHILLERES ARTES Y OFICIOS</td>
            <td>165</td>
          </tr>
          {/* Agrega más filas si lo requieres */}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="2">
              <strong>Total</strong>
            </td>
            <td>
              <strong>53509</strong>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default TablaTrabajadoresCentros;
